export const getBrowseAndSearchItemIds = (products = []) => {
  return products.map(({ itemId }) => itemId);
};
